import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
const objections = [{
  q: 'Otra marca "con proteína" de mentira, total son 2g y ya está.',
  a: <>
        La cantidad está{' '}
        <b className="font-extrabold text-white" data-id="element-79">
          declarada en la etiqueta aprobada por ANMAT
        </b>
        . No es una promesa de marketing: es un rótulo que tenés que poder
        mostrar ante cualquier organismo. Los números exactos los compartimos
        con la lista de espera.
      </>
}, {
  q: 'Vi mil de estos en TikTok que después no llegan a la Argentina o no tienen papeles en orden.',
  a: <>
        Cofit se fabrica en la Argentina, con{' '}
        <b className="font-extrabold text-white" data-id="element-80">
          registro RNE habilitado por ANMAT
        </b>
        . No depende de que te lo traiga alguien en la valija ni de un local
        "importado" sin respaldo.
      </>
}, {
  q: 'Esto lo replica cualquiera con IA en un fin de semana.',
  a: <>
        Una web, sí. El producto, no. Detrás hay una{' '}
        <b className="font-extrabold text-white" data-id="element-81">
          fórmula propia y una habilitación de ANMAT
        </b>{' '}
        que llevan meses de desarrollo y trámites. Eso no se clona copiando una
        página.
      </>
}, {
  q: 'Me parece caro para ser "solo" un polvo instantáneo.',
  a: <>
        No es un genérico reenvasado: es una{' '}
        <b className="font-extrabold text-white" data-id="element-82">fórmula propia certificada</b>,
        hecha en Argentina, en pesos y con cuotas de MercadoPago. Pagás por lo
        que está en los papeles, no por una etiqueta linda.
      </>
}, {
  q: '¿Y si lo compro y no me cierra?',
  a: <>
        Lo probás 7 días. Si no es lo que esperabas,{' '}
        <b className="font-extrabold text-white" data-id="element-83">
          te devolvemos el 100% de tu dinero
        </b>
        . La única cosa que podés perder es la oportunidad de probarlo antes que
        se agote la primera tanda.
      </>
}];
export function Objeciones() {
  return <section className="border-b border-white/[0.16] bg-espresso-2 py-[88px]" data-id="element-84">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-85">
        <Reveal data-id="element-86">
          <Eyebrow data-id="element-87">SÉ LO QUE ESTÁS PENSANDO</Eyebrow>
        </Reveal>
        <Reveal data-id="element-88">
          <h2 className="max-w-[560px] text-[clamp(24px,3.6vw,36px)] leading-[1.1] text-white" data-id="element-89">
            VAMOS A SACARNOS LAS DUDAS DE ENCIMA, AHORA.
          </h2>
        </Reveal>

        <div className="mt-9 flex max-w-[760px] flex-col" data-id="element-90">
          {objections.map((item, i) => <Reveal key={i} className={`border-b border-white/[0.16] py-6 ${i === 0 ? 'border-t' : ''}`} data-id="element-91">
              <p className="mb-2 text-base font-extrabold text-camel-light" data-id="element-92">
                <span className="text-camel" data-id="element-93">“</span>
                {item.q}
                <span className="text-camel" data-id="element-94">”</span>
              </p>
              <p className="max-w-[640px] text-[15px] font-medium text-white/[0.78]" data-id="element-95">
                {item.a}
              </p>
            </Reveal>)}
        </div>

        <Reveal className="mt-[34px] flex max-w-[680px] items-center gap-4 border border-camel/35 border-l-4 border-l-camel bg-camel/[0.08] px-[22px] py-5" data-id="element-96">
          <div className="font-display text-[38px] leading-none text-camel" data-id="element-97">
            7
          </div>
          <div className="text-[14.5px] font-semibold text-white/90" data-id="element-98">
            días de garantía.{' '}
            <b className="font-extrabold text-white" data-id="element-99">
              Si no te convence, te devolvemos la plata.
            </b>{' '}
            Sin letra chica.
          </div>
        </Reveal>
      </div>
    </section>;
}